import React, { useState } from "react";

function FAQItem({ question, answer }) {
  const [isAnswerVisible, setIsAnswerVisible] = useState(false);

  const toggleAnswerVisibility = () => {
    setIsAnswerVisible(!isAnswerVisible);
  };

  return (
    <div className="faq-item my-3">
      <div className="faq-question flex items-center">
        <button
          onClick={toggleAnswerVisibility}
          className="bg-gray-600 rounded-full text-white w-5 h-5 flex justify-center items-center mr-3"
        >
          <p>{isAnswerVisible ? "-" : "+"}</p>
        </button>
        <h1 className="font-medium">{question}</h1>
      </div>
      <div
        className={`faq-answer ml-8 transition-max-height duration-500 ease-in-out ${
          isAnswerVisible ? "max-h-96" : "max-h-0 overflow-hidden"
        }`}
      >
        {answer}
      </div>
    </div>
  );
}

const ServiceDetails = () => {
  return (
    <div className="flex">
      {/* Sidebar */}
      <div className="w-1/4 p-4 h-96 sticky top-0  border-r-1 border-black">
        <ul className="text-xl items-end ml-auto flex flex-col mt-6">
          <li className="mb-2">
            <a href="#included" className="text-gray-800 ">
              Included
            </a>
          </li>
          <li className="mb-2">
            <a href="#excluded" className="text-gray-800 ">
              Excluded
            </a>
          </li>
          <li className="mb-2">
            <a href="#faq" className="text-gray-800 ">
              FAQ
            </a>
          </li>
        </ul>
      </div>

      {/* Content */}
      <div className="w-3/4 px-8 my-8 h-96 overflow-y-auto scrollbar-hide transition-all duration-1000 ease-in-out scroll-smooth">
        <h1 id="included" className="text-3xl font-bold mb-4">
          What's Included?
        </h1>
        <ul className="ml-4">
          <li className="mb-2">
            In the fast-paced digital age, the television has become an integral
            part of our daily lives, serving as a primary source of
            entertainment, information, and connectivity. However, like any
            sophisticated electronic device, LCD/LED TVs are susceptible to
            malfunctions, requiring expert repair services to ensure
            uninterrupted viewing pleasure. Our LCD/LED TV Repair Services are
            dedicated to providing swift, reliable, and cost-effective solutions
            to address a wide array of television issues. Our team of highly
            trained and experienced technicians specializes in diagnosing and
            repairing various LCD/LED TV problems. Whether it's a flickering
            screen, distorted images, no power, sound issues, or any other
            technical glitch, our experts are equipped with the knowledge and
            tools to identify the root cause and implement effective solutions.
            We understand the importance of a properly functioning TV in your
            home or business, and we strive to deliver timely services to
            minimize downtime. One of the key aspects that sets our repair
            services apart is our commitment to transparency and integrity.
            Before initiating any repairs, our technicians conduct a thorough
            assessment of the TV and provide a detailed estimate of the expected
            costs. We believe in keeping our customers informed every step of
            the way, ensuring that there are no surprises when it comes to
            service charges. Our competitive pricing and honest approach make us
            a trusted choice for LCD/LED TV repairs.
          </li>
          <li className="mb-2">
            TV Wall Mount Installation Services Enhancing your viewing
            experience and optimizing your space, TV wall mount installation is
            a popular choice for modern homes and businesses. Our TV Wall Mount
            Installation Services offer a professional and efficient solution to
            safely mount your television, creating a sleek and space-saving
            setup that complements the aesthetics of your room. Our skilled
            technicians bring a wealth of experience to the table, ensuring that
            the TV wall mount installation is executed with precision and care.
            We understand that every installation is unique, and our experts
            assess the specific requirements of your space to determine the most
            suitable mounting solution. Whether it's a flat wall mount, tilt
            mount, or full-motion mount, we have the expertise to securely mount
            your TV according to your preferences. Safety is a top priority for
            us, and our technicians follow industry standards and guidelines to
            guarantee a secure and stable installation. We take into account the
            type of wall, the weight and size of your TV, and any additional
            factors that may impact the installation process. Our goal is not
            only to provide a visually appealing setup but also to ensure the
            safety of your valuable equipment.
          </li>
        </ul>

        <h1 id="excluded" className="text-3xl font-bold my-4">
          What’s Excluded?
        </h1>
        <ul className="ml-4">
          <li className="mb-2">
            - Price of additional materials or parts (if needed)
          </li>
          <li className="mb-2">
            - Transportation cost for carrying new materials/parts (if
            applicable)
          </li>
          <li className="mb-2">
            - Warranty on consumable materials/parts - TV Wall Mount
            Installation TV Wall Mount Installation TV Wall Mount Installation
            TV Wall Mount Installation TV Wall Mount Installation TV Wall Mount
            Installation TV Wall Mount Installation TV Wall Mount Installation
            TV Wall Mount Installation TV Wall Mount Installation TV Wall Mount
            Installation TV Wall Mount Installation TV Wall Mount Installation
            TV Wall Mount Installation TV Wall Mount Installation TV Wall Mount
            Installation TV Wall Mount Installation TV Wall Mount Installation
            TV Wall Mount Installation TV Wall Mount Installation TV Wall Mount
            Installation TV Wall Mount Installation TV Wall Mount Installation
            TV Wall Mount Installation TV Wall Mount Installation TV Wall Mount
            Installation TV Wall Mount Installation TV Wall Mount Installation
            TV Wall Mount Installation TV Wall Mount Installation TV Wall Mount
            Installation TV Wall Mount Installation TV Wall Mount Installation
            TV Wall Mount Installation TV Wall Mount Installation TV Wall Mount
            Installation TV Wall Mount Installation
          </li>
        </ul>

        <h1 id="faq" className="text-3xl font-bold my-4">
          FAQ
        </h1>
        <FAQItem
          question="How do I use this component?"
          answer="The cost is calculated based on the amount of paint used for painting walls.To help you understand we’ve added an example: A room that is 10 x 15 feet with an 9-foot ceiling. The room has two doors and two windows. Measure the total distance (perimeter) around the room. (10 ft. + 15 ft.) x 2 = 50 ft. Multip"
        />
        <FAQItem
          question="What is React?"
          answer="React is a JavaScript library for building user interfaces."
        />
        <FAQItem
          question="How do I use this component?"
          answer="The cost is calculated based on the amount of paint used for painting walls.To help you understand we’ve added an example: A room that is 10 x 15 feet with an 9-foot ceiling. The room has two doors and two windows. Measure the total distance (perimeter) around the room. (10 ft. + 15 ft.) x 2 = 50 ft. Multiply the perimeter by the ceiling height to get the total wall area: 50 ft. x 9 ft. = 450 sq. ft. Doors are usually 21 square feet (there are two in this example): 21 sq. ft. x 2 = 42 sq. ft. Windows average 15 square feet (there are two in this example): 15 sq. ft. x 2 = 30 sq. ft. Take the total wall area and subtract the area for the doors and windows to get the wall surface to be painted: 450 sq. ft. (wall area) – 42 sq. ft. (doors) – 30 sq. ft. (windows) = 378 sq. ft. of walls that needs to be painted. You can calculate the quantity of ceiling paint needed for the ceiling by multiplying the width of the room by its length: 10 ft. x 15 ft. = 150 sq. ft. So in this example total paint surface is 528 sq. ft."
        />
      </div>
    </div>
  );
};

export default ServiceDetails;
